import React from 'react'
import MessagePointData from '../../Components/Data/MessagePointData'

const index = props => {
  return <MessagePointData />
}

export default index
